import React from 'react';
import {Dates} from '../utils';
import {subscribeToNothing, subscribeToSeconds} from './clockSubscription';

// Same shape as useCurrentTime: the clock is an external store, the label is
// formatted during render so a new timestamp shows in that render, and React's
// `Object.is` on the snapshot keeps a card that shows "5 minutes ago" from
// re-rendering every second to say it again.
const useTimeDifference = (timestamp: number | null | undefined) =>
  React.useSyncExternalStore(
    timestamp ? subscribeToSeconds : subscribeToNothing,
    () => (timestamp ? Dates.formatTimeDifference(timestamp) : ''),
  );

export default useTimeDifference;
